import React from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { Box, Tabs, Tab } from "@mui/material";
import MyBookings from "../MyBookings/bookings"; // Importing the MyBookings component
import BookingPage from "..";
import { useState, useEffect } from "react";
import PersonIcon from "@mui/icons-material/Person";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import TimelineIcon from "@mui/icons-material/Timeline";
import ApiMethods from "../../../../ApiManager/ApiMethods";
import moment from "moment";

const UserDetails = () => {
  const { client: navClient } = useLocation().state || {}; // Get the client data passed via navigate (state)
  const { id } = useParams();
  const navigate = useNavigate();

  const [fetchedClient, setFetchedClient] = useState(null);
  const client = navClient || fetchedClient;

  // A deep link/refresh has no nav state — fetch the client directly so the
  // screen still works instead of getting stuck on "Loading..." or crashing
  // when the Booking/History tabs read client.id.
  useEffect(() => {
    if (navClient || !id) return;
    ApiMethods.get(`client/${id}`)
      .then((response) => setFetchedClient(response))
      .catch((err) => console.error("Error fetching client:", err));
  }, [navClient, id]);

  const [value, setValue] = React.useState(0);

  // Function to handle tab changes
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  // Render different content based on selected tab
  const renderContent = () => {
    switch (value) {
      case 0:
        return (
          <div
            className="tab-content"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              paddingTop: "200px",
            }}
          >
            <div
              style={{
                width: "300px",
                padding: "20px",
                border: "1px solid #ddd",
                borderRadius: "10px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                backgroundColor: "#fff",
                textAlign: "center",
                position: "relative",
              }}
            >
              <div
                className="circle-card"
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                  backgroundColor: "#4caf50",
                  position: "absolute",
                  top: "-25px",
                  left: "calc(50% - 25px)",
                }}
              ></div>
              <h3 style={{ marginTop: "30px", marginBottom: "20px" }}>
                Client Details
              </h3>
              {client ? (
                <div>
                  <p>
                    <strong>Name:</strong> {client.first_name || "Missing"}{" "}
                    {client.last_name || "Missing"}
                  </p>
                  <p>
                    <strong>Email:</strong> {client.email || "Missing"}
                  </p>
                  <p>
                    <strong>Phone:</strong> {client.phone || "Missing"}
                  </p>
                  {/* Secondary/optional info — unlike Name/Email/Phone above, these only render
                      when actually set (no "Missing" placeholder clutter for fields most members
                      won't have filled in). */}
                  {client.birthday && (
                    <p style={{ color: "#6b7688", fontSize: "13px" }}>
                      <strong>Datum rođenja:</strong>{" "}
                      {moment(client.birthday).format("DD.MM.YYYY")}
                    </p>
                  )}
                  {client.height != null && client.height !== "" && (
                    <p style={{ color: "#6b7688", fontSize: "13px" }}>
                      <strong>Visina:</strong> {client.height} cm
                    </p>
                  )}
                  {client.weight != null && client.weight !== "" && (
                    <p style={{ color: "#6b7688", fontSize: "13px" }}>
                      <strong>Težina:</strong> {client.weight} kg
                    </p>
                  )}
                </div>
              ) : (
                <p>Loading client details...</p>
              )}
            </div>
          </div>
        );
      case 1:
        return (
          <div className="tab-content">
            {client && (
              <BookingPage
                client_id={client.id ? client.id : client.client_id}
                view={true}
              />
            )}
          </div>
        );
      case 2:
        return (
          <div className="tab-content">
            {client && (
              <MyBookings
                client_id={client.id ? client.id : client.client_id}
              />
            )}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        backgroundColor: "white",
      }}
    >
      <Box sx={{ flex: 1 }}>{renderContent()}</Box>

      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: "black",
          boxShadow: 3,
          zIndex: 10,
        }}
      >
        <Tabs
          value={value}
          onChange={handleTabChange}
          variant="fullWidth"
          textColor="primary"
          indicatorColor="primary"
          aria-label="Client navigation tabs"
          className="custom-tabs"
        >
          <Tab
            label={
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  color: "white",
                }}
              >
                <PersonIcon style={{ fontSize: "24px" }} />
                <span style={{ fontSize: "10px" }}>User details</span>
              </div>
            }
          />
          <Tab
            label={
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <CalendarMonthIcon style={{ fontSize: "24px" }} />
                <span style={{ fontSize: "10px" }}>Booking</span>
              </div>
            }
          />
          <Tab
            label={
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <TimelineIcon style={{ fontSize: "24px" }} />
                <span style={{ fontSize: "10px" }}>History</span>
              </div>
            }
          />
        </Tabs>
      </Box>
    </div>
  );
};

export default UserDetails;
